import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export default function initAnimateTimeline() {
  const isPresent = document.querySelectorAll(".timeline-scrolled-border");

  if (!isPresent.length) {
    return;
  }

  gsap.to(".timeline-scrolled-border", {
    scaleY: 1,
    ease: "none",
    scrollTrigger: {
      trigger: ".timeline-list",
      start: "top center",
      end: "bottom center",
      scrub: true,
    },
  });

  gsap.utils.toArray(".timeline-list-item").forEach((item) => {
    const itemTrigger = ScrollTrigger.create({
      trigger: item,
      start: "top center",
      end: "bottom center",
      onEnter: () => item.classList.add("viewed"),
      onLeaveBack: () => item.classList.remove("viewed"),
      markers: false, // Set to true to see markers during development
    });
  });
}
